import { observer } from 'mobx-react-lite';
import { FC, useCallback } from 'react';

import { useCallContext } from '@gem/call/CallView/CallView.context';
import { IcCollapseIcon, IcExpandIcon } from '@gem/icons';
import { IconButton, IconViewSizes } from '@gem/ui-kit';

interface IFullScreenButtonProps {
  className?: string;
}

export const FullScreenButton: FC<IFullScreenButtonProps> = observer(({ className }) => {
  const { call } = useCallContext();

  const onClick = useCallback(() => {
    if (call.viewState.isFullScreen) {
      call.viewState.hideBackgroundPanel();

      call.viewState.collapse();
    } else {
      call.viewState.expand();
    }
  }, [call.viewState.isFullScreen]);

  return (
    <IconButton
      dataTest="callview-call-additional-actions-panel-minimize-button"
      Icon={call.viewState.isFullScreen ? IcCollapseIcon : IcExpandIcon}
      onClick={onClick}
      size={IconViewSizes.Big}
      theme="12"
      iconSize={IconViewSizes.Medium}
      className={className}
    />
  );
});
